import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Terms = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const content = {
    en: {
      title: "TERMS & CONDITIONS",
      lastUpdated: "Last updated: January 2025",
      sections: [
        {
          title: "1. General",
          content: "These Terms and Conditions govern the purchase of products from Fight like a GYAL. By placing an order, you agree to these terms."
        },
        {
          title: "2. Products",
          content: "Our products are self-defense tools intended for personal protection purposes only. By purchasing, you confirm that:\n• You are at least 18 years old\n• You will use products only for legitimate self-defense\n• You are aware of and will comply with local laws regarding possession and use of self-defense products"
        },
        {
          title: "3. Prices & Payment",
          content: "• All prices are in Euros (€) and include applicable taxes\n• Payment is processed securely through PayPal\n• Orders are confirmed only after successful payment\n• We reserve the right to refuse orders"
        },
        {
          title: "4. Shipping",
          content: "• We ship to France, Spain, and the European Union\n• Shipping costs are calculated at checkout\n• Free shipping on orders over €50\n• Delivery times: 3-5 business days (France/Spain), 5-10 business days (rest of EU)\n• Risk passes to buyer upon delivery"
        },
        {
          title: "5. Right of Withdrawal",
          content: "Under EU consumer protection law, you have 14 days from delivery to withdraw from your purchase without giving a reason.\n\nTo exercise this right:\n• Contact us via Instagram @fightlikeagyal\n• Return products in original, unused condition\n• You bear the cost of return shipping\n• Refund will be processed within 14 days of receiving returned items"
        },
        {
          title: "6. Returns & Refunds",
          content: "• Products must be returned unused, in original packaging\n• Damaged or used products cannot be returned\n• Refunds exclude original shipping costs (unless product is defective)\n• For defective products, contact us immediately with photos"
        },
        {
          title: "7. Warranty",
          content: "• Products are covered by legal warranty against manufacturing defects\n• Warranty period: 2 years from delivery\n• Warranty does not cover damage from misuse or normal wear"
        },
        {
          title: "8. Limitation of Liability",
          content: "• Fight like a GYAL is not responsible for misuse of products\n• We are not liable for injuries caused by improper use\n• Users are responsible for knowing and following local laws\n• Products are for self-defense only; any illegal use is the buyer's responsibility"
        },
        {
          title: "9. Intellectual Property",
          content: "All content on this website (logos, images, text) is property of Fight like a GYAL and protected by copyright law."
        },
        {
          title: "10. Applicable Law",
          content: "These terms are governed by French law. Any disputes shall be submitted to the competent courts of France."
        },
        {
          title: "11. Contact",
          content: "For any questions regarding these terms:\nEmail: fightlikeagyal@gmail.com\nInstagram: @fightlikeagyal"
        }
      ]
    },
    es: {
      title: "TÉRMINOS Y CONDICIONES",
      lastUpdated: "Última actualización: Enero 2025",
      sections: [
        {
          title: "1. General",
          content: "Estos Términos y Condiciones regulan la compra de productos en Fight like a GYAL. Al realizar un pedido, aceptas estos términos."
        },
        {
          title: "2. Productos",
          content: "Nuestros productos son herramientas de defensa personal destinadas únicamente a la protección personal. Al comprar, confirmas que:\n• Tienes al menos 18 años\n• Usarás los productos solo para legítima defensa\n• Conoces y cumplirás las leyes locales sobre posesión y uso de productos de defensa personal"
        },
        {
          title: "3. Precios y Pago",
          content: "• Todos los precios están en Euros (€) e incluyen impuestos aplicables\n• El pago se procesa de forma segura a través de PayPal\n• Los pedidos se confirman solo después del pago exitoso\n• Nos reservamos el derecho de rechazar pedidos"
        },
        {
          title: "4. Envío",
          content: "• Enviamos a Francia, España y la Unión Europea\n• Los gastos de envío se calculan en el checkout\n• Envío gratis en pedidos superiores a 50€\n• Tiempos de entrega: 3-5 días laborables (Francia/España), 5-10 días laborables (resto UE)\n• El riesgo pasa al comprador en la entrega"
        },
        {
          title: "5. Derecho de Desistimiento",
          content: "Según la ley de protección al consumidor de la UE, tienes 14 días desde la entrega para desistir de tu compra sin dar motivo.\n\nPara ejercer este derecho:\n• Contáctanos vía Instagram @fightlikeagyal\n• Devuelve los productos en su estado original, sin usar\n• Los gastos de devolución corren por tu cuenta\n• El reembolso se procesará en 14 días desde recibir los artículos"
        },
        {
          title: "6. Devoluciones y Reembolsos",
          content: "• Los productos deben devolverse sin usar, en embalaje original\n• Los productos dañados o usados no pueden devolverse\n• Los reembolsos excluyen los gastos de envío originales (salvo producto defectuoso)\n• Para productos defectuosos, contáctanos inmediatamente con fotos"
        },
        {
          title: "7. Garantía",
          content: "• Los productos están cubiertos por garantía legal contra defectos de fabricación\n• Período de garantía: 2 años desde la entrega\n• La garantía no cubre daños por mal uso o desgaste normal"
        },
        {
          title: "8. Limitación de Responsabilidad",
          content: "• Fight like a GYAL no es responsable del mal uso de los productos\n• No somos responsables de lesiones causadas por uso inadecuado\n• Los usuarios son responsables de conocer y seguir las leyes locales\n• Los productos son solo para defensa personal; cualquier uso ilegal es responsabilidad del comprador"
        },
        {
          title: "9. Propiedad Intelectual",
          content: "Todo el contenido de este sitio web (logos, imágenes, texto) es propiedad de Fight like a GYAL y está protegido por derechos de autor."
        },
        {
          title: "10. Ley Aplicable",
          content: "Estos términos se rigen por la ley francesa. Cualquier disputa se someterá a los tribunales competentes de Francia."
        },
        {
          title: "11. Contacto",
          content: "Para cualquier pregunta sobre estos términos:\nEmail: fightlikeagyal@gmail.com\nInstagram: @fightlikeagyal"
        }
      ]
    },
    fr: {
      title: "CONDITIONS GÉNÉRALES DE VENTE",
      lastUpdated: "Dernière mise à jour : Janvier 2025",
      sections: [
        {
          title: "1. Général",
          content: "Les présentes Conditions Générales de Vente régissent l'achat de produits sur Fight like a GYAL. En passant commande, vous acceptez ces conditions."
        },
        {
          title: "2. Produits",
          content: "Nos produits sont des outils d'autodéfense destinés uniquement à la protection personnelle. En achetant, vous confirmez que :\n• Vous avez au moins 18 ans\n• Vous utiliserez les produits uniquement pour la légitime défense\n• Vous connaissez et respecterez les lois locales concernant la possession et l'utilisation de produits d'autodéfense"
        },
        {
          title: "3. Prix et Paiement",
          content: "• Tous les prix sont en Euros (€) et incluent les taxes applicables\n• Le paiement est traité de manière sécurisée via PayPal\n• Les commandes ne sont confirmées qu'après paiement réussi\n• Nous nous réservons le droit de refuser des commandes"
        },
        {
          title: "4. Livraison",
          content: "• Nous livrons en France, Espagne et Union Européenne\n• Les frais de livraison sont calculés lors du paiement\n• Livraison gratuite pour les commandes de plus de 50€\n• Délais de livraison : 3-5 jours ouvrés (France/Espagne), 5-10 jours ouvrés (reste UE)\n• Le risque passe à l'acheteur à la livraison"
        },
        {
          title: "5. Droit de Rétractation",
          content: "Conformément au droit de la consommation européen, vous disposez de 14 jours à compter de la livraison pour vous rétracter sans donner de motif.\n\nPour exercer ce droit :\n• Contactez-nous via Instagram @fightlikeagyal\n• Retournez les produits dans leur état d'origine, non utilisés\n• Les frais de retour sont à votre charge\n• Le remboursement sera effectué dans les 14 jours suivant la réception des articles"
        },
        {
          title: "6. Retours et Remboursements",
          content: "• Les produits doivent être retournés non utilisés, dans leur emballage d'origine\n• Les produits endommagés ou utilisés ne peuvent être retournés\n• Les remboursements excluent les frais de livraison initiaux (sauf produit défectueux)\n• Pour les produits défectueux, contactez-nous immédiatement avec des photos"
        },
        {
          title: "7. Garantie",
          content: "• Les produits sont couverts par la garantie légale contre les défauts de fabrication\n• Période de garantie : 2 ans à compter de la livraison\n• La garantie ne couvre pas les dommages dus à une mauvaise utilisation ou à l'usure normale"
        },
        {
          title: "8. Limitation de Responsabilité",
          content: "• Fight like a GYAL n'est pas responsable de la mauvaise utilisation des produits\n• Nous ne sommes pas responsables des blessures causées par une utilisation inappropriée\n• Les utilisateurs sont responsables de connaître et de respecter les lois locales\n• Les produits sont destinés uniquement à l'autodéfense ; toute utilisation illégale est de la responsabilité de l'acheteur"
        },
        {
          title: "9. Propriété Intellectuelle",
          content: "Tout le contenu de ce site web (logos, images, texte) est la propriété de Fight like a GYAL et est protégé par le droit d'auteur."
        },
        {
          title: "10. Loi Applicable",
          content: "Les présentes conditions sont régies par le droit français. Tout litige sera soumis aux tribunaux compétents de France."
        },
        {
          title: "11. Contact",
          content: "Pour toute question concernant ces conditions :\nEmail : fightlikeagyal@gmail.com\nInstagram : @fightlikeagyal"
        }
      ]
    }
  };

  const c = content[lang] || content.en;

  return (
    <div className="min-h-screen pt-20 bg-[#050505]" data-testid="terms-page">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <FileText className="w-12 h-12 text-[#FF0099] mx-auto mb-4" />
          <h1 className="font-heading text-4xl text-white font-bold mb-2">{c.title}</h1>
          <p className="text-[#666666] text-sm">{c.lastUpdated}</p>
        </div>

        <div className="space-y-8">
          {c.sections.map((section, index) => (
            <div key={index} className="bg-[#1A1A1A] border border-[#333333] p-6">
              <h2 className="font-heading text-lg text-white font-bold mb-4">{section.title}</h2>
              <p className="text-[#A3A3A3] text-sm leading-relaxed whitespace-pre-line">{section.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link to="/legal" className="text-[#FF0099] hover:text-[#FAFF00] transition-colors text-sm">
            ← Back to Legal Information
          </Link>
        </div>
      </div>
    </div>
  );
};
